import { Button, Col, Row, Spin, message } from 'antd';
import { useEffect, useState } from 'react';
import { getAsset } from '../../../../services/general';
import { consultationService } from '../../../../services/medicalConsultation';
import NormalForm from './NormalForm';

const InterconsultationForm = ({inputs, ...props}) => {
  const [prescriptions, setPrescriptions] = useState([]);
  const [loadingPrescriptions, setLoadingPrescriptions] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState({});

  useEffect(() => {
    if (!inputs?.parent_medical_consultation_detail_id) return;

    const fetchPrescriptions = async () => {
      try {
        setLoadingPrescriptions(true);
        const response = await consultationService.getGeneratedPrescriptions({
          medical_consultation_detail_id: inputs.parent_medical_consultation_detail_id,
        });
        setPrescriptions(response || []);
      } catch (error) {
        console.error('Error al obtener hojas de interconsulta:', error);
        message.error({
          content: 'Ha ocurrido un error al obtener hojas de interconsulta.',
          style: { marginTop: '35vh' },
        });
      } finally {
        setLoadingPrescriptions(false);
      }
    };

    fetchPrescriptions();
  }, [inputs?.parent_medical_consultation_detail_id]);

  const downloadPrescription = async (prescription) => {
    try {
      setLoadingDownload(previous => ({ ...previous, [prescription.id]: true }));

      const response = await getAsset({
        id: prescription.id,
        field: 'document',
        type: 'MedicalPrescription',
      });

      if (response?.document_url && !response?.missing) {
        const file = await fetch(response.document_url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/pdf' },
        });
        const blob = await file.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${prescription.document_file_name?.trim() || prescription.id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } else {
        message.error({
          content: 'Ha ocurrido un error al descargar la hoja de interconsulta.',
          style: { marginTop: '35vh' },
        });
      }
    } catch (error) {
      console.error('Error al descargar hoja de interconsulta:', error);
      message.error({
        content: 'Ha ocurrido un error al descargar la hoja de interconsulta.',
        style: { marginTop: '35vh' },
      });
    } finally {
      setLoadingDownload(previous => ({ ...previous, [prescription.id]: false }));
    }
  };

  return (
    <div className="interconsultation-form">
      {inputs?.parent_medical_consultation_detail_id && (
        <Row className="mb-20">
          <Col lg={24} xs={24}>
            <p className="secondary mb-10"><strong>Hoja de interconsulta</strong></p>
            <Spin spinning={loadingPrescriptions}>
              {prescriptions.map(prescription => (
                <Row key={prescription.id} className="mb-10" align="middle">
                  <Col>
                    <Button
                      className="cmt-button primary"
                      type="primary"
                      loading={loadingDownload[prescription.id]}
                      onClick={() => downloadPrescription(prescription)}
                    >
                      <i className="icon-system-download mr-5" />
                      {prescription.interconsultation_motive || prescription.prescription_name || prescription.document_file_name || 'Descargar hoja de interconsulta'}
                    </Button>
                  </Col>
                </Row>
              ))}
              {!loadingPrescriptions && prescriptions.length === 0 && (
                <p className="secondary">No se encontró hoja de interconsulta en la consulta original.</p>
              )}
            </Spin>
          </Col>
        </Row>
      )}
      <NormalForm inputs={inputs} {...props} />
    </div>
  );
};

export default InterconsultationForm;
